import { useState, useEffect, useCallback } from 'react';
import { EditOutlined, FormOutlined } from '@ant-design/icons';
import { AModal, ASwitch, AInput } from '../../../components';
import { Form } from 'antd';
import { useToast } from '../../../hooks/toast';
import {
  schemaAccessGroupCreate,
  schemaAccessGroupEdit,
} from '../schemas/yup.access-group.schema';
import { IAccessGroup } from '../../../shared/interfaces';
import { patchAccessGroup, postAccessGroup } from '../../../http';

interface IAccessGroupProps {
  open: boolean;
  close: () => void;
  accessGroup: IAccessGroup | null;
  setAccessGroups: React.Dispatch<React.SetStateAction<IAccessGroup[]>>;
}

const AccessGroupCreateEdit: React.FC<IAccessGroupProps> = ({
  open,
  close,
  accessGroup,
  setAccessGroups,
}) => {
  const { addToast } = useToast();
  const [description, setDescription] = useState<string>('');
  const [status, setStatus] = useState<boolean>(false);

  const handleCreate = useCallback(async () => {
    schemaAccessGroupCreate
      .validate({
        description,
      })
      .then(async (validated) => {
        await postAccessGroup(validated)
          .then((data) => {
            setAccessGroups((state) => [...state, data]);
            addToast({
              type: 'success',
              title: 'Cadastrado',
              description: 'Cadastrado com sucesso.',
            });
            close();
          })
          .catch((error) => {
            addToast({
              type: 'error',
              title: 'Erro',
              description: error.response.data.error ?? 'Erro ao cadastrar',
            });
          });
      })
      .catch((err) => {
        addToast({
          type: 'error',
          title: 'Campos em branco',
          description: err.errors[0],
        });
      });
  }, [description, addToast, close, setAccessGroups]);

  const handleEdit = useCallback(async () => {
    schemaAccessGroupEdit
      .validate({
        description,
        status,
      })
      .then(async (validated) => {
        await patchAccessGroup(accessGroup?.id, validated)
          .then((data) => {
            setAccessGroups((state) =>
              state.map((e) => (e.id !== data.id ? e : data)),
            );
            addToast({
              type: 'info',
              title: 'Alterado',
              description: 'Dados alterados com sucesso.',
            });
            close();
          })
          .catch((error) => {
            addToast({
              type: 'error',
              title: 'Erro',
              description: error.response.data.error ?? 'Erro ao Editar',
            });
          });
      });
  }, [description, status, accessGroup?.id, addToast, close, setAccessGroups]);

  useEffect(() => {
    if (accessGroup) {
      setDescription(accessGroup.description);
      setStatus(accessGroup.status);
    }
  }, [open]);

  return (
    <AModal
      open={open}
      close={close}
      title={
        accessGroup ? (
          <>
            <EditOutlined /> Editar
          </>
        ) : (
          <>
            <FormOutlined /> Cadastrar
          </>
        )
      }
      onOk={accessGroup ? handleEdit : handleCreate}
    >
      <Form layout="vertical" style={{ maxWidth: 600 }}>
        <Form.Item label="Descrição">
          <AInput
            placeholder="Informe a descrição"
            name="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Form.Item>
        {accessGroup && (
          <Form.Item label="Ativo">
            <ASwitch
              checked={status}
              checkedChildren="Sim"
              unCheckedChildren="Não"
              onChange={() => {
                setStatus(!status);
              }}
            />
          </Form.Item>
        )}
      </Form>
    </AModal>
  );
};

export default AccessGroupCreateEdit;
